<template>
  <div v-if="tags.length > 0" class="tags_filter flex flex-wrap items-center gap-2 rounded-b-lg border border-t-0 border-border bg-linear-to-r from-bg-surface to-bg-elevated px-4 py-2.5 shadow-sm" role="toolbar" :aria-label="messages.filterStrip.toolbarLabel">
    <span class="inline-flex min-h-6 items-center rounded-full border border-border bg-bg px-2 font-mono text-xs font-semibold uppercase tracking-wide text-text-muted">{{ messages.filterStrip.filterRosterChip }}</span>
    <button v-for="tag in tags" :key="tag.id" type="button" class="inline-flex min-h-7 items-center gap-1.5 rounded-md px-2.5 text-xs font-semibold shadow-sm transition-[background-color,border-color,color,box-shadow] duration-200 hover:shadow-md focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-accent" :class="tagChipClassFor({ color: tag.color, active: activeFilter === tag.id })" :aria-pressed="activeFilter === tag.id ? 'true' : 'false'" @click="emit('filter-click', tag.id)">
      <span v-if="isOfficer" class="size-1.5 rounded-full" :class="tagSwatchClassFor(tag.color)" aria-hidden="true" />
      {{ tagDisplayName(tag.name) }}
    </button>
    <button v-if="activeFilter !== null" type="button" class="inline-flex min-h-7 items-center rounded-md border border-dashed border-border px-2.5 text-xs font-semibold uppercase tracking-wide text-text-secondary transition-[border-color,color,background-color] duration-200 hover:border-accent hover:bg-accent/8 hover:text-accent focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-accent" @click="emit('filter-click', activeFilter)">{{ messages.filterStrip.clearFilterButton }}</button>
  </div>
</template>

<script setup lang="ts">
import { defineLocaleCatalog } from '@/shared/i18n'
import { useLocaleMessages } from '@/shared/composables/useI18n'
import { tagChipClassFor, tagDisplayName, tagSwatchClassFor } from '@/features/gvg-planner/composables'
import type { PlayerTag } from '@/features/gvg-planner/types'
import { playerTagsEn } from './locales/en.ts'
import { playerTagsRu } from './locales/ru.ts'

export interface TagFilterStripProps {
  readonly tags: ReadonlyArray<PlayerTag>
  readonly activeFilter: string | null
  readonly isOfficer: boolean
}

defineProps<TagFilterStripProps>()
const emit = defineEmits<{
  (event: 'filter-click', tagId: string): void
}>()

const messages = useLocaleMessages(defineLocaleCatalog({ en: playerTagsEn, ru: playerTagsRu }))
</script>